import { render, staticRenderFns } from "./addLearnTuition.vue?vue&type=template&id=0994d1e3&scoped=true&"
import script from "./addLearnTuition.vue?vue&type=script&lang=js&"
export * from "./addLearnTuition.vue?vue&type=script&lang=js&"
import style0 from "./addLearnTuition.vue?vue&type=style&index=0&id=0994d1e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0994d1e3",
  null
  
)

export default component.exports